import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import OpeningHours from "./containers/OpeningHours";
import Vacation from "./containers/Vacation";
import Overview from "./containers/Overview";
import Login from "./containers/Login";

export default function Routes(props) {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/admin/overview" exact component={Overview} />
      <Route path="/admin/vacation" exact component={Vacation} />
      <Route path="/admin/openinghours" exact component={OpeningHours} />
      <Route path="/admin/login" component={Login} />
      {/*<Route path="/admin" component={Settings} />
      <Route path="/map" exact component={HomeMap} />
      <Route path="/login" exact component={Login} />
      <Route path="/signup" exact component={Signup} />
      <Route component={NotFound} />*/}
    </Switch>
  );
}